import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Container, Card, Form, Button } from "react-bootstrap";
import "./index.css"; 
import { useAuth } from "../../../Utils/Auth";
import { CreateIntroducerSchema } from "../../../Services/schema";
import { customErrorHandler, toTitleCase } from "../../../Utils/helper";
import FullScreenLoader from "../../../Component/FullScreenLoader";
import introducerService from "../../../Services/apiService/introducer-service";

const CreateIntroducer = () => {
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      userName: "",
      password: "",
    },
    validationSchema: CreateIntroducerSchema,
    onSubmit: (values) => {
      introducerFormHandler(values);
    },
  });

  const introducerFormHandler = (values) => {
    setIsLoading(true);
    introducerService.createIntroducer(values, auth.user)
      .then((res) => {
        toast.success(toTitleCase(res?.data?.message));
        resetForm();
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(toTitleCase(customErrorHandler(err)));
      });
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <Container fluid className="introducer-container">
      <FullScreenLoader show={isLoading} />
      <Card className="introducer-card">
        <Card.Body>
          <h2 className="introducer-title">Create New Introducer</h2>
          <Form onSubmit={handleSubmit}>
            <div className="row g-3">
              {/* Username Field */}
              <div className="col-md-6">
                <Form.Group controlId="userName">
                  <Form.Label>Username <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="userName"
                    value={values.userName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Username"
                    isInvalid={touched.userName && !!errors.userName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.userName}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              {/* Password Field */}
              <div className="col-md-6">
                <Form.Group controlId="password">
                  <Form.Label>Password <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="Password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Create Password"
                    isInvalid={touched.password && !!errors.password}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              {/* First Name Field */}
              <div className="col-md-6">
                <Form.Group controlId="firstName">
                  <Form.Label>First Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter First Name"
                    isInvalid={touched.firstName && !!errors.firstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.firstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              {/* Last Name Field */}
              <div className="col-md-6">
                <Form.Group controlId="lastName">
                  <Form.Label>Last Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Last Name"
                    isInvalid={touched.lastName && !!errors.lastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.lastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>

            <div className="d-grid mt-4">
              <Button variant="primary" type="submit" size="lg" className="submit-btn mb-3">
                CREATE INTRODUCER
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CreateIntroducer;